/* eslint-disable */
( function( $ ) {

	window.GPLimitCheckboxes = function( args ) {

		var self = this;

		// copy all args to current object: (list expected props)
		for ( prop in args ) {
			if ( args.hasOwnProperty( prop ) ) {
				self[ prop ] = args[ prop ];
			}
		}

		self.init = function() {

			if ( window.GPLimitCheckboxes && ! window.GPLimitCheckboxes.instances ) {
				window.GPLimitCheckboxes.instances = {};
			}

			self.bindTriggerEvents();
			self.listenForChanges();

			window.GPLimitCheckboxes.instances[ self.formId ] = self;

		};

		self.resetCheckboxElemCache = function () {
			self.checkboxElemCache = {};
		};

		self.bindTriggerEvents = function() {

			var selectors = [];
			var triggers  = $.map(self.triggers, function (value) {
				return value;
			});

			for ( var i = 0; i < triggers.length; i++ ) {
				selectors.push( triggers[ i ].selector );
			}

			var $elems = $( selectors.join( ', ' ) );

			self.resetCheckboxElemCache();

			// Clear pre-disabled markers when a field becomes enabled (e.g., via conditional logic).
			$elems.filter( '.gplc-pre-disabled:not(:disabled)' ).removeClass( 'gplc-pre-disabled' );

			// Exclude choices that were already disabled so that they will always be disabled.
			$elems.each( function() {
				var $parent = $( this ).parents( '.gfield' );
				// On AJAX-enabled forms, GF will evaluate conditional logic *before* GPLC can test for checkboxes which
				// are disabled by default. If the field is hidden by conditional logic, GPLC will incorrectly think that
				// it is disabled by default. Let's account for this...
				// Added a second check to prevent double binding making deselected checkboxes permanently disabled.
				if ( ( ! $parent.data( 'gf-disabled-assessed' ) || $( this ).hasClass( 'gf-default-disabled' ) ) && ! $( this ).hasClass( 'gplc-disabled' ) ) {
					$( this ).filter( ':disabled' ).addClass( 'gplc-pre-disabled' );
				}
			} );

			// Exclude Select All choices.
			$elems.filter( 'input[id$="select_all"]' ).addClass( 'gplc-select-all' );

			$elems.off( 'change.gplc' ).on( 'change.gplc', function() {
				self.handleCheckboxClick( $( this ) );
			} ).each( function() {
				self.handleCheckboxClick( $( this ) );
			} );

		};

		self.listenForChanges = function() {
			$(document).on('gppa_updated_batch_fields', function(event, formId) {
				if (formId != self.formId) {
					return;
				}

				self.bindTriggerEvents();
			});

			gform.addAction( 'gpi_field_refreshed', function( $targetField, $triggerField, initialLoad ) {
				var formId = $targetField
					.closest('form')
					.prop('id')
					.replace('gform_', '');

				if (formId != self.formId) {
					return;
				}

				self.bindTriggerEvents();
			} );

			// Re-evaluate limits after conditional logic runs. Only needed when limits
			// span multiple fields, as single-field limits are unaffected by CL changes.
			var hasSpannedGroups = self.groups.some( function( group ) {
				return group.fields.length > 1;
			} );

			if ( hasSpannedGroups ) {
				$( document ).off( 'gform_post_conditional_logic.gplc_' + self.formId );
				$( document ).on( 'gform_post_conditional_logic.gplc_' + self.formId, function( event, formId ) {
					if (formId != self.formId) {
						return;
					}

					// GF fires gform_post_conditional_logic once per field. Use requestAnimationFrame
					// to coalesce these into a single bindTriggerEvents() call before the next paint.
					if ( ! self._clPending ) {
						self._clPending = true;
						requestAnimationFrame( function() {
							self._clPending = false;
							self.bindTriggerEvents();
						} );
					}
				} );
			}
		}

		self.handleCheckboxClick = function( $elem ) {

			var disableFieldIds = [],
				enableFieldIds  = [],
				fieldId         = typeof $elem != 'undefined' ? parseInt( $elem.attr( 'id' ).split( '_' )[2] ) : null;

			/**
			 * Filter the input selectors used to exclude inputs from being checked/unchecked.
			 *
			 * @since 1.3.11
			 *
			 * @param array  excludedInputSelectors Input selectors to exclude from checking/unchecking.
			 * @param int    fieldId The ID of the field that triggered the event.
			 * @param object $elem   A jQuery object of the element that triggered the event.
			 * @param object gplc    The current instance of the GPLimitCheckboxes object.
			 */
			var excludedInputSelectors = window.gform.applyFilters('gplc_excluded_input_selectors', [], fieldId, $elem, self ).join( ', ' );

			// loops through ALL groups to make sure that overlapping groups are covered
			for ( var i = 0; i < self.groups.length; i++ ) {

				/**
				 * Filter the group of checkboxes that are about to be processed.
				 *
				 * @since 1.2
				 *
				 * @param object group   The current group.
				 * @param int    fieldId The ID of the field that triggered the event.
				 * @param object $elem   A jQuery object of the element that triggered the event.
				 * @param object gplc    The current instance of the GPLimitCheckboxes object.
				 */
				var group = gform.applyFilters( 'gplc_group', $.extend( true, {}, self.groups[ i ] ), fieldId, $elem, self );

				if ( self.isGroupMaxed( group ) ) {
					$.merge( disableFieldIds, group.fields );
				} else {
					$.merge( enableFieldIds, group.fields );
				}

			}

			// remove disabled fields from the enableFieldIds array
			enableFieldIds = GPLimitCheckboxes.diff( enableFieldIds, disableFieldIds );

			if ( enableFieldIds.length ) {

				var $enableFields = self.getCheckboxesByFieldIds( enableFieldIds );
				var $form         = $( '#gform_' + self.formId );
				var $excludeNota  = $();

				// Exclude fields which have 'gw-none-of-the-above' class
				// Ref: https://gravitywiz.com/snippet-library/gw-none-of-the-above-checkbox/
				if ( $form.hasClass( 'gw-none-of-the-above' ) ) {
					$excludeNota = $enableFields.filter(function() {
						return this.closest('.gw-none-of-the-above') !== null;
					});
				}

				// Enable applicable checkboxes.
				$enableFields.not( '.gplc-pre-disabled, .gplc-select-all' )
					.not( excludedInputSelectors )
					.not( $excludeNota )
					.attr( 'disabled', false )
					.removeClass( 'gplc-disabled' );
			}

			if ( disableFieldIds.length ) {

				var $disableFields = self.getCheckboxesByFieldIds( disableFieldIds );

				// Disable applicable checkboxes.
				$disableFields.not( ':checked, .gplc-pre-disabled, .gplc-select-all' )
					.not( excludedInputSelectors )
					.attr( 'disabled', true )
					.addClass( 'gplc-disabled' );

				// Supports GF 2.3 Select All option; uncheck any disabled checkbox that was not pre-disabled. Potential
				// complications: this does not trigger onclick events.
				$disableFields
					.filter( ':checked:disabled:not( .gplc-pre-disabled )' )
					.not( excludedInputSelectors )
					.attr( 'checked', false ).trigger( 'change' );

			}

		};

		self.getCheckboxCheckedCount = function( group ) {
			var count = 0;
			$( self.getSelector( group.fields ) ).filter( ':checked:not( .gplc-select-all )' ).each( function() {
				var idIndex = this.id.split( '_' );
				/**
				 * Filter the count value of each checkbox in a field.
				 * Useful when trying to specify a custom weighted value for some checkboxes.
				 *
				 * @since 1.3.1
				 *
				 *
				 * @param number value    Value of the current choice, default 1.
				 * @param number formId   The ID of the current form.
				 * @param number fieldId  The ID of the current Checkbox field.
				 * @param number choice   The sequence number of the current Checkbox (starts from 1).
				 */
				count += gform.applyFilters( 'gplcb_checkbox_count', 1, self.formId, parseInt( idIndex[2] ), parseInt( idIndex[3] ) );
			} );

			return count;
		}

		self.isGroupMaxed = function( group ) {
			return self.getCheckboxCheckedCount( group ) >= group.max;
		};

		self.isGroupBelowMin = function( group ) {
			return self.getCheckboxCheckedCount( group ) < group.min;
		};

		self.getSelector = function( fieldIds ) {
			var selectors = [];

			for ( var i = 0; i < fieldIds.length; i++ ) {
				var fieldId = fieldIds[i];

				if ( ! (fieldId in self.triggers)) {
					continue;
				}

				selectors.push( self.triggers[fieldId].selector );
			}

			return selectors.join( ', ' );
		};

		self.getCheckboxesByFieldIds = function( fieldIds ) {
			var fieldIdsJoined = fieldIds.join( ',' );

			if ( ! (fieldIdsJoined in self.checkboxElemCache) ) {
				self.checkboxElemCache[fieldIdsJoined] = $( self.getSelector( fieldIds ) );
			}

			return self.checkboxElemCache[fieldIdsJoined];
		};

		self.isFieldHidden = function( fieldId ) {
			var $field = $( '#input_' + self.formId + '_' + fieldId );
			return gformIsHidden( $field.children( ':first-child' ) );
		};

		GPLimitCheckboxes.diff = function( a, b ) {
			return a.filter( function( i ) {
				return b.indexOf( i ) < 0;
			} );
		};

		self.init();

	};

} )( jQuery );
